// src/data/retailers.ts

import type { Retailer } from "@/types";

export const RETAILERS: Retailer[] = [
  {
    id:             "org-mhw",
    name:           "Midwest Hardware",
    vertical:       "Home Improvement & Hardware",
    loyaltyMembers: 2_840_000,
    matchRate:      92,
  },
  {
    id:             "org-fmg",
    name:           "FreshMart Grocery",
    vertical:       "Grocery & Mass Retail",
    loyaltyMembers: 5_120_000,
    matchRate:      89,
  },
  {
    id:             "org-sna",
    name:           "StyleNow Apparel",
    vertical:       "Fashion & Apparel",
    loyaltyMembers: 1_670_000,
    matchRate:      87,
  },
];

// ── Loyalty enrichment summary per retailer ──────────────────
export interface LoyaltyEnrichmentSummary {
  retailerId:        string;
  totalMembers:      number;
  enrichedMembers:   number;
  lapseRiskCount:    number;
  conquestProspects: number;
  crossSellOpps:     number;
  avgIntentScore:    number;
  lastRefreshed:     string;
  intentOverlays: {
    topic:       string;
    memberCount: number;
    avgScore:    number;
  }[];
  spendCategories: {
    category: string;
    members:  number;
    revenue:  number;
  }[];
}

export const LOYALTY_SUMMARIES: LoyaltyEnrichmentSummary[] = [
  {
    retailerId:        "org-mhw",
    totalMembers:      2_840_000,
    enrichedMembers:   2_612_000,
    lapseRiskCount:    184_000,
    conquestProspects: 920_000,
    crossSellOpps:     430_000,
    avgIntentScore:    67,
    lastRefreshed:     "2026-03-17T06:00:00Z",
    intentOverlays: [
      { topic: "Power Tools",        memberCount: 680_000, avgScore: 74 },
      { topic: "Home Improvement",   memberCount: 940_000, avgScore: 71 },
      { topic: "Outdoor & Garden",   memberCount: 520_000, avgScore: 65 },
      { topic: "Smart Home Devices", memberCount: 310_000, avgScore: 69 },
      { topic: "Competitor Research",memberCount: 142_000, avgScore: 81 },
    ],
    spendCategories: [
      { category: "Power Tools",    members: 680_000, revenue: 48_200_000 },
      { category: "Hand Tools",     members: 920_000, revenue: 31_400_000 },
      { category: "Paint & Supplies",members: 540_000,revenue: 18_700_000 },
      { category: "Outdoor & Garden",members: 480_000,revenue: 22_100_000 },
      { category: "Electrical",     members: 360_000, revenue: 14_300_000 },
    ],
  },
  {
    retailerId:        "org-fmg",
    totalMembers:      5_120_000,
    enrichedMembers:   4_780_000,
    lapseRiskCount:    412_000,
    conquestProspects: 1_840_000,
    crossSellOpps:     870_000,
    avgIntentScore:    61,
    lastRefreshed:     "2026-03-17T06:00:00Z",
    intentOverlays: [
      { topic: "Organic Food",        memberCount: 1_240_000, avgScore: 72 },
      { topic: "Meal Kits",           memberCount:   680_000, avgScore: 68 },
      { topic: "Grocery Delivery",    memberCount:   920_000, avgScore: 75 },
      { topic: "Health & Wellness",   memberCount:   760_000, avgScore: 66 },
      { topic: "Competitor Grocery",  memberCount:   310_000, avgScore: 79 },
    ],
    spendCategories: [
      { category: "Fresh Produce",  members: 3_200_000, revenue: 124_000_000 },
      { category: "Dairy & Eggs",   members: 4_100_000, revenue: 89_000_000  },
      { category: "Meat & Seafood", members: 2_800_000, revenue: 112_000_000 },
      { category: "Beverages",      members: 3_600_000, revenue: 67_000_000  },
      { category: "Snacks",         members: 3_900_000, revenue: 54_000_000  },
    ],
  },
  {
    retailerId:        "org-sna",
    totalMembers:      1_670_000,
    enrichedMembers:   1_490_000,
    lapseRiskCount:    98_000,
    conquestProspects: 640_000,
    crossSellOpps:     220_000,
    avgIntentScore:    63,
    lastRefreshed:     "2026-03-17T06:00:00Z",
    intentOverlays: [
      { topic: "Women's Fashion",    memberCount: 740_000, avgScore: 71 },
      { topic: "Athletic Wear",      memberCount: 380_000, avgScore: 74 },
      { topic: "Sustainable Fashion",memberCount: 210_000, avgScore: 67 },
      { topic: "Luxury Brands",      memberCount: 140_000, avgScore: 62 },
      { topic: "Competitor Apparel", memberCount:  88_000, avgScore: 77 },
    ],
    spendCategories: [
      { category: "Women's Apparel", members: 980_000, revenue: 62_000_000 },
      { category: "Men's Apparel",   members: 540_000, revenue: 34_000_000 },
      { category: "Footwear",        members: 420_000, revenue: 28_000_000 },
      { category: "Accessories",     members: 380_000, revenue: 18_000_000 },
      { category: "Kids' Clothing",  members: 290_000, revenue: 14_000_000 },
    ],
  },
];